import React from "react";
import styles from "./loader.module.scss";

const SpinnerLoader = () => {
	return (
		<div id="spinner" className={`${styles.loadingSpinnerDualRing}`}>
			<div className={styles.ldio}>
				<div></div>
				<div>
					<div></div>
				</div>
			</div>
		</div>
	);
};

export { SpinnerLoader };
